import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const VerificationPendingFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg width={size} height={size} viewBox="0 0 21 20" fill="none" {...props}>
    <G clipPath="url(#clip0_1304_54251)">
      <Path
        d="M17.4498 4.96653C17.4415 4.79153 17.3581 4.62486 17.2248 4.49986C17.0915 4.3832 16.9165 4.32486 16.7415 4.3332C13.4665 4.54986 10.9498 2.24153 10.9248 2.21653C10.6581 1.96653 10.2415 1.9832 9.99148 2.24153C7.83314 4.5082 4.29148 4.32486 4.25814 4.32486C4.08314 4.31653 3.90814 4.37486 3.77481 4.49153C3.64148 4.6082 3.56648 4.77486 3.54981 4.94986C3.27481 10.3582 3.85814 16.1165 10.3331 17.8332C10.3915 17.8499 10.4498 17.8582 10.5081 17.8582C10.5665 17.8582 10.6248 17.8582 10.6831 17.8332C17.1498 16.1165 17.7415 10.3499 17.4665 4.94986L17.4498 4.96653ZM11.1831 13.3415C10.9998 13.5249 10.7748 13.6249 10.4998 13.6249C10.2248 13.6249 9.99148 13.5332 9.80814 13.3415C9.62481 13.1582 9.53314 12.9249 9.53314 12.6499C9.53314 12.3749 9.62481 12.1499 9.80814 11.9582C9.99148 11.7665 10.2248 11.6749 10.4998 11.6749C10.7748 11.6749 10.9998 11.7665 11.1831 11.9582C11.3665 12.1415 11.4581 12.3749 11.4581 12.6499C11.4581 12.9249 11.3665 13.1499 11.1831 13.3415ZM11.5581 7.59153L11.0248 10.6915C11.0081 10.8665 10.9498 10.9999 10.8498 11.0915C10.7498 11.1832 10.6331 11.2332 10.4915 11.2332C10.3498 11.2332 10.2331 11.1832 10.1331 11.0915C10.0331 10.9999 9.97481 10.8665 9.94981 10.6915L9.43314 7.5832C9.43314 7.5832 9.42481 7.49153 9.42481 7.42486C9.42481 7.12486 9.52481 6.89153 9.73314 6.71653C9.94148 6.54153 10.1915 6.4582 10.4998 6.4582C10.8081 6.4582 11.0665 6.54153 11.2665 6.71653C11.4665 6.89153 11.5665 7.12486 11.5665 7.42486C11.5665 7.49153 11.5665 7.54153 11.5581 7.5832V7.59153Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1304_54251">
        <Rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default VerificationPendingFilled
